<template>
  <v-app-bar
    absolute
    app
    color="transparent"
    flat
    height="75"
    style="width: auto"
  >
    <v-btn fab small @click="setDrawer(!drawer)">
      <v-icon v-if="value"> mdi-view-quilt </v-icon>

      <v-icon v-else> mdi-dots-vertical </v-icon>
    </v-btn>

    <v-toolbar-title class="hidden-sm-and-down" v-text="$route.name" />

    <v-spacer />

    <div class="mx-3" />

    <v-menu
      bottom
      left
      min-width="200"
      offset-y
      origin="top right"
      transition="scale-transition"
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn min-width="0" text v-bind="attrs" v-on="on">
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </template>

      <v-list :tile="false" flat nav>
        <template v-for="(p, i) in profile">
          <v-divider v-if="p.divider" :key="`divider-${i}`" class="mb-2 mt-2" />

          <app-bar-item v-else :key="`item-${i}`" to="/" v-on:click="p.onclick">
            <v-list-item-title v-text="p.title" />
          </app-bar-item>
        </template>
        <div @click="_logout">
          <app-bar-item to="/">
            <v-list-item-title v-text="'Logout'" />
          </app-bar-item>
        </div>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
  /* eslint-disable */
// Components
import { VHover, VListItem } from "vuetify/lib";

// Utilities
import { mapState, mapMutations } from "vuex";
import EventEmitter from "../../../../utils/event-emitter";

export default {
  name: "DashboardCoreAppBar",

  components: {
    AppBarItem: {
      render(h) {
        return h(VHover, {
          scopedSlots: {
            default: ({ hover }) => h(
                VListItem,
                {
                  attrs: this.$attrs,
                  class: {
                    "black--text": !hover,
                    "white--text secondary elevation-12": hover,
                  },
                  props: {
                    activeClass: "",
                    dark: hover,
                    link: true,
                    ...this.$attrs,
                  },
                },
                this.$slots.default
              ),
          },
        });
      },
    },
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    notifications: [
      "Mike John Responded to your email",
      "You have 5 new tasks",
      `You're now friends with Andrew`,
      "Another Notification",
      "Another one",
    ],
    profile: [{ title: "Profile" }, { title: "Settings" }, { divider: true }],
  }),

  computed: {
    ...mapState(["drawer"]),
  },

  methods: {
    _showBulkMessageComposer() {
      EventEmitter.dispatch("show-group-bulk-sms-composer");
    },
    _showBulkEmailComposer() {
      EventEmitter.dispatch("show-group-bulk-email-composer");
    },
    async _logout() {
      if (window.confirm("Are you sure want to logout?")) {
        try {
          localStorage.clear();
          this.$auth.signOut();
        } catch (error) {
          console.log(error);
        }
        // this.$router.push("/login");
      }
    },
    ...mapMutations({
      setDrawer: "SET_DRAWER",
    }),
  },
};
</script>

<style lang="scss" scoped>
.quick-comm-btn {
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  margin-right: 15px;
  align-items: center;
  background-color: black;
  box-shadow: 5px 5px 8px rgba(0, 0, 0, 0.12);
  color: white;
  font-size: 17px;
  * {
    font-size: 17px;
    color: white;
  }
  border-radius: 100px;
}
</style>
